import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from './Button';

const SignaturePad = ({ onSave, onClear, label, required = false, error = '' }) => {
  const sigRef = useRef(null);

  const handleClear = () => {
    if (sigRef.current) {
      sigRef.current.clear();
      onClear && onClear();
    }
  };

  const handleEnd = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      const dataUrl = sigRef.current.toDataURL('image/png');
      onSave(dataUrl);
    }
  };

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className={`border-2 border-dashed rounded-lg ${error ? 'border-red-500' : 'border-red-300'}`}>
        <SignatureCanvas
          ref={sigRef}
          penColor="#C62828"
          canvasProps={{
            width: 400,
            height: 150,
            className: 'w-full rounded-lg bg-gray-50'
          }}
          onEnd={handleEnd}
        />
      </div>
      <div className="flex items-center justify-between mt-2">
        <p className="text-xs text-gray-500">Gacanta ku saxiix</p>
        <Button type="button" variant="ghost" size="sm" onClick={handleClear}>
          Tirtir
        </Button>
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default SignaturePad;